export default __webpack_public_path__ + "static/media/female developer 2-01.647e78e8.jpg";